/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Post_Surgery_RehabInputs */

const en_service_type_post_surgery_rehab = /** @type {(inputs: Service_Type_Post_Surgery_RehabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Post-surgery rehab`)
};

const pl_service_type_post_surgery_rehab = /** @type {(inputs: Service_Type_Post_Surgery_RehabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rehabilitacja pooperacyjna`)
};

/**
* | output |
* | --- |
* | "Post-surgery rehab" |
*
* @param {Service_Type_Post_Surgery_RehabInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_post_surgery_rehab = /** @type {((inputs?: Service_Type_Post_Surgery_RehabInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Post_Surgery_RehabInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_post_surgery_rehab(inputs)
	return en_service_type_post_surgery_rehab(inputs)
});